export const i18nData = {
  CampaignSelector_List_Header: _TL_('Available entities: {{itemCount}}'),
  CampaignSelector_EmptyList_Content: _TL_('No items found'),
  EntitySelector_Pagination_Page: _TL_('Page: '),
  EntitySelector_Pagination_TotalPageCountText: _TL_(' of '),
  EntitySelector_Pagination_PreviousPageText: _TL_('Previous page'),
  EntitySelector_Pagination_NextPageText: _TL_('Next page'),
  EntitySelector_Search_Placeholder: _TL_('search'),
  CampaignSelector_SelectCampaign: _TL_('Select campaign'),
  CampaignSelector_SelectCampaigns: _TL_('Select campaigns'),
  CampaignSelector_Result_List_Header: _TL_('selected entities: {{itemCount}}'),
  CampaignSelector_Result_Action_Bar: _TL_('Select all on this page'),
  'Remove all': _TL_('Remove all'),
  Done: _TL_('Done'),
  Cancel: _TL_('Cancel'),
};

